
import { useState } from 'react';
//====================  css =============
import "./event.css";
//============ other assets ===============
import sliderImg from "assets/Images/bg/event.png";
// import calendarImg from "assets/Images/icons/calendar.png";
// import { Swiper, SwiperSlide } from "swiper/react";
// import SwiperCore, { Pagination, Navigation, Autoplay } from "swiper";
import CustomInput from "Utills/CustomInput/CustomInput"
import { Button } from '@material-ui/core';
import CustomModel from "Utills/Model/CustomModel"
import { Calendar } from "react-date-range";
// import Moment from 'moment';
import { Slide } from "react-reveal";

//================= Swiper slider configs =================
// SwiperCore.use([Pagination, Navigation, Autoplay]);

//============================  THIS IS A EVENT PAGE =================================
const Event = () => {
    // calendar modal state
    const [openCalendar, setOpenCalendar] = useState(false);
    // form data
    const [formData, setFormData] = useState({
        description: ''
    });

    // images array for first section slider 
    // const images = [
    //     sliderImg,
    //     sliderImg,
    //     sliderImg,
    // ];

    // go to the section
    const scrollTo_Section = (sec_id) => {
        let element = document.getElementById(sec_id);
        const yOffset = -127;
        if (element) {
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    //==================== islands list data ======================
    let islandList = [
        { name: "Weddings", },
        { name: "VIP Events", },
        { name: "Ceremonies/ Galas", },
        { name: "Private Parties", },
    ];

    return (
        <div className="event-page">
            <div className="event-slider-wrapper">
                {/* <Swiper
                    className="event-slider-container"
                    autoplay={{ disableOnInteraction: false, delay: 4500 }}
                    speed={500}
                    initialSlide={0}
                    pagination={{
                        clickable: true,
                    }}
                    spaceBetween={15}
                    grabCursor
                    loop
                    onBeforeInit={(swiper) => {
                        swiper.params.pagination.el = ".event-slider-paging";
                        swiper.params.pagination.bulletActiveClass = "active-event-paging-item";
                        swiper.params.pagination.bulletClass = "custom-paging-event-slider";
                        swiper.params.pagination.clickable = true;
                        swiper.params.pagination.renderBullet = (index, className) => {
                            return (
                                ` <span class="event-slider-bullets ${className}"></span>`
                            )
                        };
                    }}
                >
                    {images.map((image, index) => (
                        <SwiperSlide key={index} className="event-slider-card"> */}
                <div className="event-slider-card">
                    <img
                        className="event-slider-img"
                        src={sliderImg}
                        alt="cyan"
                    />
                </div>
                {/* </SwiperSlide>
                    ))}
                </Swiper> */}
                <div className="event-slider-paging"></div>
                {/* <div className="event-page-hero-heading">
                    <h1>Events Management</h1>
                </div> */}
                <div className="event-page-hero-bottom-sec">
                    <Slide bottom>
                        <h1>Events Management</h1>
                        <br />
                        <button onClick={() => scrollTo_Section('book_now_form')}>Book your event now</button>
                        <p>If you’re looking for a unique event experience, you are at the right place.</p>
                    </Slide>
                </div>
            </div>
            <div className="cs_container mt-md-5 mt-3">
                <div className="row overflow-hidden py-md-4 py-3">
                    <div className="col-12 ">
                        <Slide bottom>
                            <div className="our-story-head center-head-line">
                                <h2>Event Types</h2>
                            </div>
                        </Slide>
                    </div>
                    <Slide bottom cascade>
                        <div className="row py-4 justify-content-sm-center justify-content-between px-sm-0 px-3 align-items-center">
                            {islandList.map((land) => (
                                <div className="offer_placeCard d-flex justify-content-center align-items-center">
                                    <h5 className="px-2">{land.name}</h5>
                                </div>
                            ))}
                        </div>
                    </Slide>
                    {/* <div className="col-md-8 mx-auto my-3">
                        <p className="text-sec text-center">
                            Whether you have a party, wedding or formal event.. Book now and experience Joy. We offer this service for all greek islands with flexible booking system
                        </p>
                    </div> */}
                </div>
            </div>
            <div className="event-page_sec2 overflow-hidden">
                <div className="cs_container">
                    <Slide bottom cascade>
                        <div className="event-page-sec2-content">
                            <h3>Private Yacht Parties</h3>
                            <h4>All- included</h4>
                            <button className="cs-btn cs-outline" onClick={() => scrollTo_Section('book_now_form')}>Book your event now</button><br />
                            {/* <span>Available for all greek islands</span> */}
                        </div>
                    </Slide>
                </div>
            </div>
            <div className="cs_container mt-md-5 pt-md-4">
                <div className="row py-4" id='book_now_form'>
                    <div className="col-12 ">
                        <Slide bottom>
                            <div className="our-story-head center-head-line">
                                <h2 className="py-1">Event Form</h2>
                            </div>
                        </Slide>
                    </div>
                    <div className="col-md-8 mx-auto mt-1 mb-md-4">
                        <Slide bottom>
                            <p className="text-pr text-center">
                                Fill the following form and one of our experienced coordinators will be in touch with you within 1 hour!
                            </p>
                        </Slide>
                    </div>
                    <div className="col-md-8 col-12 mx-auto p-0 my-4">
                        <form action="" onSubmit={(e) => e.preventDefault()}>
                            <div className="row overflow-hidden m-0 p-md-0 p-3">
                                <div className="col-md-10">
                                    <div className="main-input d-flex my-1 justify-content-between align-items-center">
                                        <div className="profile-labels event-label text-gr text-left">
                                            <Slide left>
                                                <label htmlFor="">First name</label>
                                            </Slide>
                                        </div>
                                        <div className="profile-inputs-wrapper">
                                            <Slide right>
                                                <CustomInput required name="boat_name" blueborder={"true"} placeholder="First name"
                                                // onChange={(e)=> handlePersonalForm(e)} value={data.first_name} 
                                                />
                                            </Slide>
                                        </div>
                                    </div>
                                    <div className="main-input d-flex my-1 justify-content-between align-items-center">
                                        <div className="profile-labels event-label text-gr text-left ">
                                            <Slide left>
                                                <label htmlFor="">Last name</label>
                                            </Slide>
                                        </div>
                                        <div className="profile-inputs-wrapper">
                                            <Slide right>
                                                <CustomInput required name="boat_name" blueborder={"true"} placeholder="Last name"
                                                // onChange={(e)=> handlePersonalForm(e)} value={data.first_name} 
                                                />
                                            </Slide>
                                        </div>
                                    </div>
                                    <div className="main-input d-flex my-1 justify-content-between align-items-center">
                                        <div className="profile-labels event-label text-gr text-left ">
                                            <Slide left>
                                                <label htmlFor="">Mobile</label>
                                            </Slide>
                                        </div>
                                        <div className="profile-inputs-wrapper">
                                            <Slide right>
                                                <CustomInput required name="boat_name" blueborder={"true"} placeholder="Enter mobile number"
                                                // onChange={(e)=> handlePersonalForm(e)} value={data.first_name} 
                                                />
                                            </Slide>
                                        </div>
                                    </div>
                                    <div className="main-input d-flex my-1 justify-content-between align-items-center">
                                        <div className="profile-labels event-label text-gr text-left ">
                                            <Slide left>
                                                <label htmlFor="">Email</label>
                                            </Slide>
                                        </div>
                                        <div className="profile-inputs-wrapper">
                                            <Slide right>
                                                <CustomInput required
                                                    name="email"
                                                    blueborder={"true"} placeholder="Enter email"
                                                    type="email"
                                                // onChange={(e)=> handlePersonalForm(e)} value={data.first_name} 
                                                />
                                            </Slide>
                                        </div>
                                    </div>
                                    <div className="main-input d-flex my-1 justify-content-between align-items-center">
                                        <div className="profile-labels event-label text-gr text-left">
                                            <Slide left>
                                                <label htmlFor="">Event location</label>
                                            </Slide>
                                        </div>
                                        <div className="profile-inputs-wrapper">
                                            <Slide right>
                                                <CustomInput required
                                                    name="email"
                                                    blueborder={"true"} placeholder="Enter Location"
                                                    type="email"
                                                // onChange={(e)=> handlePersonalForm(e)} value={data.first_name} 
                                                />
                                            </Slide>
                                        </div>
                                    </div>
                                    {/* <div className="main-input d-flex my-1 justify-content-start align-items-center">
                                        <div className="profile-labels event-label text-gr text-left "><label htmlFor="">Type of event</label></div>
                                        <div className="profile-inputs-wrapper">
                                            <div className="cs-select-box">
                                                <div className="cs-select">
                                                    <select required className="cs-select" name="boat_type" id="">
                                                        {["Choose", "Event type 1", 'Event type 2', 'Event type 3'].map((value, i) => (
                                                            <option disabled={i === 0 ? true : false} selected={i === 0 ? true : false} key={i} value={i}>{value}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                    {/* <div className="main-input d-flex my-1 justify-content-between align-items-center">
                                        <div className="profile-labels event-label text-gr text-left "><label htmlFor="">Number of guests</label></div>
                                        <div className="profile-inputs-wrapper">
                                            <CustomInput required 
                                            // name="boat_name"
                                             type="number" 
                                            blueborder={"true"} placeholder="Enter"
                                            // onChange={(e)=> handlePersonalForm(e)} value={data.first_name} 
                                            />

                                        </div>
                                    </div> */}
                                    {/* <div className="main-input d-flex my-1 justify-content-start align-items-center">
                                        <div className="profile-labels event-label text-gr text-left "><label htmlFor="">Location</label></div>
                                        <div className="profile-inputs-wrapper">
                                            <div className="cs-select-box">
                                                <div className="cs-select">
                                                    <select required className="cs-select" name="boat_type" id="">
                                                        {['Choose', 'Location 1', 'Location 2', 'Location 3'].map((value, i) => (
                                                            <option disabled={i === 0 ? true : false} selected={i === 0 ? true : false} key={i} value={i}>{value}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                    {/* <div className="main-input d-flex my-1 justify-content-between align-items-center">
                                        <div className="profile-labels event-label text-gr text-left "><label htmlFor="">Date</label></div>
                                        <div className="profile-inputs-wrapper d-flex justify-content-start align-items-center">
                                            <div className="event-calendar-input-icon">
                                                <img  className="cursor-pointer"  onClick={() => setOpenCalendar(true)} src={calendarImg} alt="" />
                                            </div>
                                            <CustomInput
                                                required
                                                className="text-center cursor-pointer user-select-none"
                                                // name="boat_name" 
                                                blueborder={"true"}
                                                placeholder="mm/dd/yyyy"
                                                onClick={() => setOpenCalendar(true)}
                                                readOnly
                                                // start_icon={<img className="cursor-pointer" onClick={() => setOpenCalendar(prev => !prev)} src={CalendarIcon} alt="" />}
                                                type="text"
                                                name="date"
                                                value={formData?.date ?
                                                    Moment(formData?.date?.toString()).format("MMM Do YYYY")
                                                    : ''
                                                }
                                                // placeholder="Date of Birth"
                                            />

                                        </div>
                                    </div> */}
                                </div>
                                <div className="col-12  py-0">
                                    <div className="main-input overflow-hidden d-flex my-1 justify-content-between align-items-start">
                                        <div className="profile-labels event-label text-gr text-left ">
                                            <Slide left>
                                                <label htmlFor="">Description of happening</label>
                                            </Slide>
                                        </div>
                                        <Slide right>
                                            <div className="profile-inputs-wrapper">
                                                <textarea required className="cs-textarea" name="description" id=""
                                                    placeholder="Enter here"
                                                    onChange={(e) => {
                                                        setFormData({ ...formData, 'description': e.target.value?.length < 500 ? e.target.value : e.target.value?.slice(0, 500) })
                                                    }}
                                                    value={formData.description}
                                                ></textarea>
                                            </div>
                                        </Slide>
                                    </div>
                                    <div className="w-100 d-flex justify-content-end align-items-center overflow-hidden">
                                        <Slide right>
                                            <span className="text-gr">{formData?.description?.trim().length}/500</span>
                                        </Slide>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 text-center">
                                <Slide bottom>
                                    <Button className="siginin_form_btn mt-2 mb-2 text-white px-5" type="submit">Submit &nbsp; Request</Button>
                                </Slide>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {/* Calendar Model */}
            <CustomModel
                openPopup={openCalendar}
                setOpenPopup={setOpenCalendar}
            >
                <div className="date_menu cs_cal">
                    <div className="intradaycalender">
                        <Calendar
                            onChange={(item) => {
                                setFormData({
                                    ...formData,
                                    date: item
                                });
                                setOpenCalendar(false)
                            }}
                            date={formData.date}
                        />
                    </div>
                </div>
            </CustomModel>
        </div>
    )
}

export default Event
